export default __webpack_public_path__ + "static/media/ovitOntrak.a277da19.png";